import { defineMessages } from 'react-intl';

const messages = defineMessages({
  quickShipHeader: {
    description: 'Settings workflow quickShip header',
    defaultMessage: 'QuickShip Settings',
    id: '3Bquue',
  },
  quickShipDescription: {
    description: 'Settings workflow quickShip description',
    defaultMessage:
      'Configure your preferences below to decide which processing steps will run in the background during your label processing requests. To learn more about efficient shipping with QuickShip click <a>here</a>.',
    id: 'pvKmLU',
  },
  showErrors: {
    description: 'Settings workflow quickShipShowErrors',
    defaultMessage: 'Show Errors',
    id: 'LduSVQ',
  },
  showWarnings: {
    description: 'Settings workflow quickShipShowWarnings',
    defaultMessage: 'Show Warnings',
    id: 'PnjSQf',
  },
  showCostSummary: {
    description: 'Settings workflow quickShipShowCostSummary',
    defaultMessage: 'Show Cost Summary (<a>set up auto-funding</a>)',
    id: 'OA882S',
  },
  showPrintDialogPreview: {
    description: 'Settings workflow quickshipShowPrintDialogPreview',
    defaultMessage: 'Show Print Dialog Preview (<a>set your default printer</a>)',
    id: '43F3Fc',
  },
  showLabelBatchStatus: {
    description: 'Settings workflow quickshipShowLabelBatchStatus',
    defaultMessage: 'Show Label Batch Status',
    id: 'EAsjpV',
  },
});

export default messages;
